import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class GatewayPaymentService {
    static makeDirectBillPayment(
        accountNumber,
        request,
        additionalHeaders = {}
    ) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayBillingDirectBillPayment'),
            'makeDirectBillPayment',
            [accountNumber, request],
            additionalHeaders
        );
    }
}
